<template>
  <div class="centerStats">
    <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />
    <!-- <div class="two-columns"> -->
    <!-- <div class="column">
      <div class="chart-block">
        <h3>Извештај просечно додељених средстава по месецима</h3>
        <div class="chart-wrapper">
          <canvas ref="monthlyChart"></canvas>
        </div>
      </div>
    </div> -->
    <div class="column">
      <div class="chart-block">
        <h3>Извештај о укупно предвиђеним и додељеним средствима по години</h3>
        <div class="chart-wrapper">
          <canvas ref="monthlyChart2"></canvas>
        </div>
      </div>
    </div>
    <!-- <div class="column">
        <div class="chart-block">
          <h3>Годишња статистика</h3>
          <div class="chart-wrapper">
            <canvas ref="yearlyChart"></canvas>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
    <div class="two-columns">
      <div class="column">
        <div class="chart-block">
          <h3>Укупан број конкурса: {{ contestsCount }}</h3>
          <div class="chart-wrapper">
            <canvas ref="contestsChart"></canvas>
          </div>
        </div>
        <div class="chart-block">
          <h3>Минимална средства по пројектима</h3>
          <div class="chart-wrapper">
            <canvas ref="projectFundsChartMin"></canvas>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="chart-block">
          <h3>Укупно предвиђена средства: {{ totalFundsValueFormatted }}</h3>
          <div class="chart-wrapper">
            <canvas ref="fundsChart"></canvas>
          </div>
        </div>
        <!-- <div class="chart-block">
          <h3>Статистика примедби</h3>
          <div class="chart-wrapper">
            <canvas ref="remarksChart"></canvas>
          </div>
        </div> -->
        <!-- <div class="chart-block">
          <h3>Чланови комисије</h3>
          <div class="chart-wrapper">
            <canvas ref="commissionChart"></canvas>
          </div>
        </div> -->
        <div class="chart-block">
          <h3>Максимална средства по пројектима</h3>
          <div class="chart-wrapper">
            <canvas ref="projectFundsChartMax"></canvas>
          </div>
        </div>
      </div>

    </div>
    <div>
              <div class="chart-block">
          <h3>Укупан број предлога пројеката : {{ projectsCount }}</h3>
          <div class="chart-wrapper">
            <canvas ref="projectsChart"></canvas>
          </div>
        </div>
    </div>
    <div class="two-columns">
      <div class="column">
        <div class="chart-block">
          <h3>Најчешће одабрани / бирани чланови комисије</h3>
          <div class="chart-wrapper">
            <canvas ref="TopCommissionMembers"></canvas>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="chart-block">
          <h3>Ранг листа најчешћих добитника средстава</h3>
          <div class="chart-wrapper">
            <canvas ref="TopProjectSubmitters"></canvas>
          </div>
        </div>
      </div>

      <!-- <div class="column">
        <div class="chart-block">
          <h3>Заступљеност одобрених пројеката по јединицама</h3>
          <div class="chart-wrapper">
            <canvas ref="projectsChartPerTownship"></canvas>
          </div>
        </div>
      </div> -->
    </div>
      <div class="column">
        <div class="chart-block">
          <h3>Ранг листа добитника највиших средстава</h3>
          <div class="chart-wrapper">
            <canvas ref="TopProjectSubmitterByAmount"></canvas>
          </div>
        </div>
      </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { baseUrl } from '../env'
import LoadingModal from '@/components/LoadingModal.vue'
import { useRoute } from "vue-router";

Chart.register(ChartDataLabels)

// ✅ Custom plugin to add space between legend and chart
const legendGapPlugin = {
  id: 'legendGap',
  beforeInit(chart) {
    const originalFit = chart.legend.fit;
    chart.legend.fit = function fit() {
      originalFit.bind(chart.legend)();
      this.height += 50; // change 20 to desired gap in px
    };
  }
};

const route = useRoute();

// Refs for charts
const monthlyChart = ref(null)
const monthlyChart2 = ref(null)
// const yearlyChart = ref(null)
const contestsChart = ref(null)
const projectsChart = ref(null)
const projectsChartPerTownship = ref(null)
const fundsChart = ref(null)
const projectFundsChartMin = ref(null)
const projectFundsChartMax = ref(null)
const remarksChart = ref(null)
const givingsChart = ref(null)
const commissionChart = ref(null)
const TopCommissionMembers = ref(null)
const TopProjectSubmitters = ref(null)
const TopProjectSubmitterByAmount = ref(null)
const contestsCount = ref(0)
const projectsCount = ref(0)
const totalFundsValue = ref(0)
const totalFundsValueFormatted = computed(() =>
  totalFundsValue.value.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 0 })
)

function formatDate(day, month, year) {
  return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}.`
}


// Generate a color for each year
function getColorForYear(yearIndex, totalYears) {
  const hue = (yearIndex / totalYears) * 360; // evenly spaced hues
  return `hsl(${hue}, 70%, 50%)`;
}
// Color generator
function hslToRgba(hsl, alpha) {
  return hsl.replace("hsl", "hsla").replace(")", `, ${alpha})`);
}

const loading = ref(true)
const loadingLabel = ref('Учитавање статистике...')


const chartInstances = {
  monthly: ref(null),
  monthly2: ref(null),
  yearly: ref(null),
  contests: ref(null),
  projects: ref(null),
  funds: ref(null),
  projectFundsMin: ref(null),
  projectFundsMax: ref(null),
  remarks: ref(null),
  givings: ref(null),
  commission: ref(null),
  topCommission: ref(null),
  topSubmitters: ref(null),
  topProjectSubmitterByAmount: ref(null),
  projectsPerTownship: ref(null)
}

function destroyChart(key) {
  if (chartInstances[key]?.value) {
    chartInstances[key].value.destroy()
    chartInstances[key].value = null
  }
}
const yAxisFormat = {
  ticks: {
    callback(value) {
      if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + 'B'
      if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M'
      if (value >= 1_000) return (value / 1_000).toFixed(0) + 'K'
      return value
    }
  }
}

watch(() => route.query, () => {
  loadAllCharts()
}, { deep: true })

async function fetchStat(url, returnRaw = false) {
  const res = await axios.get(`${baseUrl}${url}`);
  const data = res.data;

  const response = (value) => {
    return returnRaw ? [value, data] : value;
  }

  if (typeof data === 'number') return response(data);
  if (typeof data.value === 'number') return response(data.value);
  if (typeof data.count === 'number') return response(data.count);
  if (Array.isArray(data)) return response(data.length);

  return response(data); // fallback
}

async function fetchStatFullApiChartObjects(url, returnRaw = false) {
  const res = await axios.get(`${baseUrl}${url}`);
  const data = res.data

  const returnValue = data.value || data.count || (Array.isArray(data) ? data.length : 0) || data;

  if (!returnRaw) {
    return returnValue
  } else {
    return [returnValue, data]
  }
}

async function loadAllCharts(allTownship, datefrom, dateto) {
  try {
    loading.value = true
    const d = new Date()
    const from = route.query.od || datefrom || '01.01.1971.'
    const to = route.query.do || dateto || `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}.`

    // Example: Fetch contests and show in chart
    const published = await fetchStat(`/query/1/${from}/${to}/${allTownship || ''}`)
    const notPublished = await fetchStat(`/query/2/${from}/${to}/${allTownship || ''}`)
    //const regular = await fetchStat(`/query/3/${from}/${to}/${allTownship || ''}`)
    contestsCount.value = published + notPublished

    if (contestsChart.value
    ) {

      destroyChart('contests')
      chartInstances.contests.value =
        new Chart(contestsChart.value.getContext('2d'), {
          type: 'bar',
          data: {
            // labels: ['Објављени', 'Необјављени', 'Редовни'],
            // datasets: [{
            //   label: 'Број конкурса',
            //   data: [published, notPublished, regular],
            //   backgroundColor: ['#4caf50', '#f44336', '#2196f3']
            //labels: ['Расписани', 'Нерасписани', 'Регуларни', 'Нерегуларни'],
            labels: ['Расписани', 'Нерасписани'],
            datasets: [{
              label: 'Број конкурса',
              // data: [published, notPublished, regular, published + notPublished - regular],
              data: [published, notPublished],
              // backgroundColor: ['#4caf50', '#f44336', '#2196f3', '#ea99a2']
               backgroundColor: ['#4caf50', '#f44336']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'top',
                font: {
                  weight: 'bold'
                },
                formatter: val => isNaN(val) ? '' : Math.round(val)
              }
            }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        })
    }

    // Статистика пројеката
    const totalProjects = await fetchStat(`/query/4/${from}/${to}/${allTownship || ''}`);
    const [grantedProjects, grantedProjectsResponse] = await fetchStat(`/query/5/${from}/${to}/${allTownship || ''}`, true);

    const grantedProjectsGrouped = grantedProjectsResponse.data.reduce((acc, item) => {
      const existing = acc[item.name] || 0;
      const granted = Number(item.granted_projects) || 0;

      return {
        ...acc,
        [item.name]: existing + granted//existing ? existing + 1 : 1
      }
    }, {})

    const top10Chart = Object.entries(grantedProjectsGrouped)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 10)
      .reduce((acc, [key, value]) => {
        const match = grantedProjectsResponse.data.find(item => item.name === key);
        acc.labels.push(key);
        acc.data.push(value);
        acc.ids.push(match ? match.id : null); // ✅ store ID

        return acc;
      }, { labels: [], data: [], ids: [] })

    projectsCount.value = totalProjects
    if (projectsChartPerTownship.value) {
      destroyChart('projectsPerTownship')
      chartInstances.projectsPerTownship.value =
        new Chart(projectsChartPerTownship.value.getContext('2d'), {
          type: 'bar',
          data: {
            labels: top10Chart.labels.map(label => {
              return label.length > 20 ? `${label.substring(0, 20)?.trim()}...` : label;
            }),
            datasets: [{
              label: 'Одобрени пројекти',
              data: top10Chart.data,
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              tooltip: {
                callbacks: {
                  title: function (context) {
                    const index = context[0].dataIndex;
                    return top10Chart.labels[index];
                  }
                }
              },
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'top',
                font: {
                  weight: 'bold'
                },
                formatter: (value) => {
                  return value
                }
              }
            },
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                const idx = elements[0].index
                const item = top10Chart.ids[idx]
                if (item) {
                  const url = `/?jedinica=${item}#t`
                  //window.location.href = url
                   window.open(url, '_blank', 'noopener,noreferrer');
                  
                }
              }
            }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        })
    }

    if (projectsChart.value) {
      const nonGrantedProjects = totalProjects - grantedProjects
      destroyChart('projects')
      chartInstances.projects.value =
        new Chart(projectsChart.value.getContext('2d'), {
          type: 'pie',
          data: {
            labels: ['Одобрени пројекти', 'Неодобрени пројекти'],
            datasets: [{
              data: [grantedProjects, nonGrantedProjects],
              backgroundColor: ['#8bc34a', '#ff9800']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                color: '#000',
                anchor: 'center',
                align: 'top',
                font: {
                  weight: 'bold'
                },
                formatter: val => isNaN(val) ? '' : Math.round(val)
              }
            }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        })
    }

    // Средства: укупна, додељена и неодељена
    const totalFunds = await fetchStat(`/query/6/${from}/${to}/${allTownship || ''}`)
    const allocatedFunds = await fetchStat(`/query/7/${from}/${to}/${allTownship || ''}`)
    /*const nonAllocatedFunds = await fetchStat(`/query/8/${from}/${to}/${allTownship || ''}`)*/
    if (fundsChart.value) {
      destroyChart('funds')
      chartInstances.funds.value = new Chart(fundsChart.value.getContext('2d'), {
        type: 'bar',
        data: {
          labels: ['Предвиђена', 'Додељена'], /*, 'Нераспоређена'*/
          datasets: [{
            label: 'Средства',
            data: [totalFunds, allocatedFunds], /*, nonAllocatedFunds*/
            backgroundColor: ['#1976d2', '#43a047', '#e53935']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#000',
              anchor: 'end',
              align: 'top',
              font: {
                weight: 'bold'
              },
              formatter: (value) => {
                return value.toLocaleString('sr-RS', {
                  style: 'currency',
                  currency: 'RSD',
                  minimumFractionDigits: 0
                });
              }
            },
            legend: {
              position: 'top'
            }
          },scales: { y: yAxisFormat }
        },
        // ✅ Pass custom plugin here, not in options
        plugins: [legendGapPlugin]

      })
    }
    totalFundsValue.value = totalFunds

    // Monthly chart example
    const startYear = 2015
    const endYear = d.getFullYear()

    //const groupedMonthlyAllocatedFunds = await fetchStatFullApiChartObjects(`/query/21/${from}/${to}/${allTownship || ''}`)
    const groupedMonthlyAllocatedFundsData = []//Object.values(groupedMonthlyAllocatedFunds).map((i) => i.average);

    if (monthlyChart.value) {
      destroyChart('monthly')
      chartInstances.monthly.value = new Chart(monthlyChart.value.getContext('2d'), {
        type: 'bar',
        data: {
          labels: ['Јануар', 'Фебруар', 'Март', 'Април', 'Мај', 'Јун', 'Јул', 'Август', 'Септембар', 'Октобар', 'Новембар', 'Децембар'],
          datasets: [{
            label: 'Просечна додељена средства (РСД)',
            data: groupedMonthlyAllocatedFundsData,
            backgroundColor: 'rgba(75,192,192,0.2)',
            borderColor: 'rgba(75,192,192,1)',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
                anchor: 'end',
                align: 'top',
                  // font: {
                  //   weight: 'normal'
                  // },
                  formatter: (value) => {
                    if (value > 1000000000) {
                      return (value / 1000000000).toFixed(1).replace('.', ',') + 'B';
                    } else {
                      return (value / 1000000).toFixed(1).replace('.', ',') + 'M';
                    }
                  }
            }
          },scales: { y: yAxisFormat }
        },
        // ✅ Pass custom plugin here, not in options
        plugins: [legendGapPlugin]
      })
    }

    // Monthly chart 2: one dataset per year
    // Example: Fetch monthly allocated funds average grouped by year and month
    //v 2 monthly

    const groupedMonthlyAllocatedFundsAvg = await fetchStatFullApiChartObjects(
      `/query/25/${from}/${to}/${allTownship || ''}`
    );

    // Extract unique years
    const allYears = [...new Set(Object.values(groupedMonthlyAllocatedFundsAvg).map(i => i.year))];

    // Compute yearly totals
    const yearlyTotals2 = {};
    Object.values(groupedMonthlyAllocatedFundsAvg).forEach(item => {
      if (!yearlyTotals2[item.year]) {
        yearlyTotals2[item.year] = { totalAloc: 0, totalFunds: 0 };
      }
      yearlyTotals2[item.year].totalAloc += item.totalAloc;
      yearlyTotals2[item.year].totalFunds += item.totalFunds;
    }); const yearColors = {};
    allYears.forEach((year, idx) => {
      yearColors[year] = getColorForYear(idx, allYears.length);
    });

    // Build 2 datasets: Allocated + Funds
    const datasets = [

      {
        label: "Светлије - Предвиђена средства",
        data: allYears.map(year => yearlyTotals2[year]?.totalFunds || 0),
        backgroundColor: allYears.map(year => hslToRgba(yearColors[year], 0.4)) // lighter
      }      ,
      {
        label: "Тамније - Додељена средства",
        data: allYears.map(year => yearlyTotals2[year]?.totalAloc || 0),
        backgroundColor: allYears.map(year => hslToRgba(yearColors[year], 0.8)) // darker
      }
    ];

    // Chart.js
    destroyChart("monthly2");
    chartInstances.monthly2.value = new Chart(monthlyChart2.value.getContext("2d"), {
      type: "bar",
      data: {
        labels: allYears, // years on x-axis
        datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top" },
          datalabels: {
            display: ctx => ctx.dataset.data[ctx.dataIndex] !== null,
            anchor: 'end',
               align: 'top',
                  // font: {
                  //   weight: 'normal'
                  // },
                  formatter: (value) => {
                    if (value > 1000000000) {
                      return (value / 1000000000).toFixed(1).replace('.', ',') + 'B';
                    } else {
                      return (value / 1000000).toFixed(1).replace('.', ',') + 'M';
                    }
                  }
          }
        } ,scales: { y: yAxisFormat }
      },
      // ✅ Pass custom plugin here, not in options
      plugins: [legendGapPlugin]
    });

    // Максимална и минимална средства по пројекту
    const [, maxRaw] = await fetchStat(`/query/9/${from}/${to}/${allTownship || ''}`, true)
    const [, minRaw] = await fetchStat(`/query/10/${from}/${to}/${allTownship || ''}`, true)

    // Extract the first items from raw API response
    //const maxItem = maxRaw?.data?.[0] || {}
    //const minItem = minRaw?.data?.[0] || {}

    if (projectFundsChartMin.value) {
      destroyChart('projectFundsMin');
      const labels = minRaw.data.slice(0, 5).map(item => {
        if (allTownship !== '' && allTownship != undefined) return '';
        return item.name || '—';
      });

      const values = minRaw.data.slice(0, 5).map(item => item.value || 0);

      chartInstances.projectFundsMin.value = new Chart(
        projectFundsChartMin.value.getContext('2d'),
        {
          type: 'bar',
          data: {
            labels,
            datasets: [{
              label: 'Мин. средства по пројекту (РСД)',
              data: values,
              backgroundColor: '#3498db'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'end',
                font: { weight: 'bold' },
                formatter: (value) => {
                  //const item = minRaw.data[context.dataIndex];
                  return `${value.toLocaleString('sr-RS', {
                    style: 'decimal',
                    currency: 'RSD',
                    minimumFractionDigits: 0, maximumFractionDigits: 0 
                  })}`;
                }
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const item = minRaw.data[context.dataIndex];
                    return [
                      `${item.value.toLocaleString('sr-RS', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
                      `Конкурс: ${item.calendar || '—'}`
                    ];
                  }
                }
              }
            },
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                //const chart = elements[0].element.$context.chart;
                const dataIndex = elements[0].index;
                const item = minRaw.data[dataIndex];
                if (item.contestId) {
                  //window.location.href = `/konkurs/${item.contestId}#t`;
                   window.open(`/konkurs/${item.contestId}#t`, '_blank', 'noopener,noreferrer');
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  callback: value => value.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 0 })
                }
              }
            }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        }
      );
    }


    if (projectFundsChartMax.value) {
      destroyChart('projectFundsMax');

      const labels = maxRaw.data.slice(0, 5).map(item => {
        if (allTownship !== '' && allTownship != undefined) return '';
        return item.name || '—';
      });
      const values = maxRaw.data.slice(0, 5).map(item => item.value || 0);

      chartInstances.projectFundsMax.value = new Chart(
        projectFundsChartMax.value.getContext('2d'),
        {
          type: 'bar',
          data: {
            labels,
            datasets: [{
              label: 'Макс. средства по пројекту (РСД)',
              data: values,
              backgroundColor: '#2ecc71'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'end',
                font: { weight: 'bold' },
                formatter: (value) => {
                  if (value >= 1_000_000_000) {
                    // Billions
                    return (value / 1_000_000_000).toFixed(1).replace('.', ',') + 'B';
                  } else if (value >= 1_000_000) {
                    // Millions
                    return (value / 1_000_000).toFixed(1).replace('.', ',') + 'M';
                  } else {
                    // Regular currency
                    return value.toLocaleString('sr-RS',{ style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
                  }
                }                      
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const item = maxRaw.data[context.dataIndex];
                    return [
                      `${item.value.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 0 })}`,
                      `Конкурс: ${item.calendar || '—'}`
                    ];
                  }
                }
              }
            },
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                // const chart = elements[0].element.$context.chart;
                const dataIndex = elements[0].index;
                const item = maxRaw.data[dataIndex];
                if (item.contestId) {
                  //window.location.href = `/konkurs/${item.contestId}#t`;
                  window.open(`/konkurs/${item.contestId}#t`, '_blank', 'noopener,noreferrer');
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  callback: value => value.toLocaleString('sr-RS', { style: 'currency', currency: 'RSD', minimumFractionDigits: 0 })
                }
              }
            }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        }
      );
    }



    // Напомене
    const mkRemarks = []//await fetchStat(`/query/11/${from}/${to}/${allTownship || ''}`)
    const someRemarks = []//await fetchStat(`/query/15/${from}/${to}/${allTownship || ''}`)
    const mk1Remarks = []//await fetchStat(`/query/16/${from}/${to}/${allTownship || ''}`)
    if (remarksChart.value) {
      destroyChart('remarks')
      chartInstances.remarks.value = new Chart(remarksChart.value.getContext('2d'), {
        type: 'pie',
        data: {
          labels: ['МК Напомене', 'Одређене напомене', 'МК1 Напомене'],
          datasets: [{
            data: [mkRemarks, someRemarks, mk1Remarks],
            backgroundColor: ['#0288d1', '#cddc39', '#f06292']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#000',
              anchor: 'center',
              align: 'top',
              font: {
                weight: 'bold'
              },
              formatter: val => isNaN(val) ? '' : Math.round(val)
            }
          }
        },
        // ✅ Pass custom plugin here, not in options
        plugins: [legendGapPlugin]
      })
    }

    // Средства давања
    const totalGivings = await fetchStat(`/query/12/${from}/${to}/${allTownship || ''}`)
    const minGivings = await fetchStat(`/query/13/${from}/${to}/${allTownship || ''}`)
    const maxGivings = await fetchStat(`/query/14/${from}/${to}/${allTownship || ''}`)
    if (givingsChart.value) {
      destroyChart('givings')
      chartInstances.givings.value = new Chart(givingsChart.value.getContext('2d'), {
        type: 'bar',
        data: {
          labels: ['Укупно давање', 'Мин. давање', 'Макс. давање'],
          datasets: [{
            label: 'Средства давања',
            data: [totalGivings, minGivings, maxGivings],
            backgroundColor: ['#00bcd4', '#ff7043', '#9ccc65']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#000',
              anchor: 'end',
              align: 'top',
              font: {
                weight: 'bold'
              },
              formatter: Math.round // Optional
            }
          }
        },
        // ✅ Pass custom plugin here, not in options
        plugins: [legendGapPlugin]
      })
    }


    // Yearly chart (same logic as monthly)
    const yearlyTotals = []
    for (let year = startYear; year <= endYear; year++) {
      const from = formatDate(1, 1, year)
      const to = formatDate(31, 12, year)
      const value = await fetchStat(`/query/7/${from}/${to}/${allTownship || ''}`)
      yearlyTotals.push(Number(value) || 0)
    }

    //      destroyChart('yearly')
    // chartInstances.yearly.value = new Chart(yearlyChart.value.getContext('2d'), {
    //       type: 'bar',
    //       data: {
    //         labels: Array.from({length: endYear - startYear + 1}, (_, i) => `${startYear + i}`),
    //         datasets: [{
    //           label: 'Додељена средства по години (РСД)',
    //           data: yearlyTotals,
    //           backgroundColor: 'rgba(75,192,192,0.2)',
    //           borderColor: 'rgba(75,192,192,1)',
    //           borderWidth: 1
    //         }]
    //       },
    //       options: {
    //         responsive: true,
    //         maintainAspectRatio: false,
    //         plugins: {
    //           datalabels: {
    //             formatter: val => `${(val / 1_000_000).toFixed(0)}M`
    //           }
    //         }
    //       }
    //     })

    // totalFundsValue.value = yearlyTotals.reduce((a, b) => a + b, 0)

    // Чланови комисије
    const namedSpecial = []//await fetchStat(`/query/17/${from}/${to}/${allTownship || ''}`)
    const suggestedSpecial = []//await fetchStat(`/query/18/${from}/${to}/${allTownship || ''}`)
    const namedCommission = []//await fetchStat(`/query/19/${from}/${to}/${allTownship || ''}`)
    if (commissionChart.value) {
      destroyChart('commission')
      chartInstances.commission.value = new Chart(commissionChart.value.getContext('2d'), {
        type: 'pie',
        data: {
          labels: ['Именовани специјални', 'Предложени специјални', 'Именована комисија'],
          datasets: [{
            data: [namedSpecial, suggestedSpecial, namedCommission],
            backgroundColor: ['#ffca28', '#ab47bc', '#26a69a']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#000',
              anchor: 'center',
              align: 'top',
              font: {
                weight: 'bold'
              },
              formatter: Math.round // Optional
            }
          }
        },
        // ✅ Pass custom plugin here, not in options
        plugins: [legendGapPlugin]
      })
    }

    const {rows: rowsCM,  chart } = await fetchStatFullApiChartObjects(`/query/23/${from}/${to}/${allTownship || ''}`);
    if (chart && chart.labels && chart.datasets && chart.datasets.length > 0) {
      if (TopCommissionMembers.value) {
        destroyChart('topCommission')
        chartInstances.topCommission.value = new Chart(TopCommissionMembers.value.getContext('2d'), {
          type: 'bar',
          data: {
            labels: chart.labels.map(label => {
              return label.length > 20 ? `${label.substring(0, 20)?.trim()}...` : label;
            }),
            datasets: chart.datasets
          },

          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'top',
                font: {
                  weight: 'bold'
                },
                formatter: Math.round // Optional
              }
            },
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                const idx = elements[0].index
                const item = rowsCM[idx]
                if (item.label) {
                  const url = `upiti?upit=22&memberName=${item.label}`
                  //window.location.href = url
                  window.open(url, '_blank', 'noopener,noreferrer');
                }
              }
            }
          }, // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        })
      }
    }


    const { rows: rowsQ, chart: newchart } = await fetchStatFullApiChartObjects(`/query/24/${from}/${to}/${allTownship || ''}?type=quantity`);
    if (newchart && newchart.labels && newchart.datasets && newchart.datasets.length > 0) {
      if (TopProjectSubmitters.value) {
        destroyChart('topSubmitters')
        chartInstances.topSubmitters.value = new Chart(TopProjectSubmitters.value.getContext('2d'), {
          type: 'bar',
          data: {
            labels: newchart.labels.map(label => {
              return label.length > 20 ? `${label.substring(0, 20)?.trim()}...` : label;
            }),
            datasets: newchart.datasets
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                  callbacks: {
                    title: function (context) {
                      const index = context[0].dataIndex;
                      return newchart.labels[index];
                    }
                  }
                },
              datalabels: {
                color: '#000',
                anchor: 'end',
                align: 'top',
                font: {
                  weight: 'bold'
                },
                formatter: Math.round // Optional
              }
            },
            onClick: (evt, elements) => {
              if (elements.length > 0) {
                const idx = elements[0].index
                const item = rowsQ[idx]
                if (item.submitter) {
                  const url = `/pretraga/podnosioc-projekta?submitter=${item.submitter}&jedinica=${allTownship || ''}`
                  //window.location.href = url
                  window.open(url, '_blank', 'noopener,noreferrer');
                }
              }
            },scales: { y: yAxisFormat }
          },
          // ✅ Pass custom plugin here, not in options
          plugins: [legendGapPlugin]
        })
      }
    }

    const { rows, chart: amountTopSubmittersChart } = await fetchStat(`/query/24/${from}/${to}/${allTownship || ''}?type=amount`);

    if (amountTopSubmittersChart && amountTopSubmittersChart.labels && amountTopSubmittersChart.datasets && amountTopSubmittersChart.datasets.length > 0) {
      if (TopProjectSubmitterByAmount.value) {
        destroyChart('topProjectSubmitterByAmount')
        chartInstances.topProjectSubmitterByAmount.value =
          new Chart(TopProjectSubmitterByAmount.value.getContext('2d'), {
            type: 'bar',
            data: {
              labels: amountTopSubmittersChart.labels.map(label => {
                return label.length > 20 ? `${label.substring(0, 20)?.trim()}...` : label;
              }),
              datasets: amountTopSubmittersChart.datasets
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                tooltip: {
                  callbacks: {
                    title: function (context) {
                      const index = context[0].dataIndex;
                      return amountTopSubmittersChart.labels[index];
                    }
                  }
                },
                datalabels: {
                  color: '#000',
                  anchor: 'end',
                  align: 'top',
                  font: {
                    weight: 'bold'
                  },
                  formatter: (value) => {
                    if (value > 1000000000) {
                      return (value / 1000000000).toFixed(1).replace('.', ',') + 'B';
                    } else {
                      return (value / 1000000).toFixed(1).replace('.', ',') + 'M';
                    }
                  }
                }
              },
              onClick: (evt, elements) => {
                if (elements.length > 0) {
                  const idx = elements[0].index
                  const item = rows[idx]
                  if (item.submitter) {
                    const url = `/pretraga/podnosioc-projekta?submitter=${item.submitter}&jedinica=${allTownship || ''}`
                    //window.location.href = url
                     window.open(url, '_blank', 'noopener,noreferrer');
                  }
                }
              },scales: { y: yAxisFormat }
            },
            // ✅ Pass custom plugin here, not in options
            plugins: [legendGapPlugin]
          })
      }
    }

    loading.value = false
  } catch
  (e) {
    console.error('Statistika greska:', e)
    loading.value = false
  }
}

onMounted(async () => {
  await loadAllCharts()
})


defineExpose({
  loadAllCharts
})

</script>

<style scoped>
.loading-overlay {
  position: relative;
  top: 35%;
  left: 50%;
  width: 10%;
  height: 10%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.chart-block {
  padding-top: 15px;
}

.chart-wrapper {
  max-width: 100%;
  width: 100%;
  height: 300px;
  position: relative;
}

.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 20px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

@media (max-width: 768px) {
  .two-columns {
    grid-template-columns: 1fr;
  }
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
